import React from "react";
import styles from "../../FilePreviewModal.module.scss";

interface CSVPreviewProps {
  rows: string[][];
  fileName?: string;
}

const CSVPreview: React.FC<CSVPreviewProps> = ({ rows, fileName }) => {
  // Function to convert rows array to CSV string
  const convertToCSV = (rows: string[][]): string => {
    return rows.map(row => 
      row.map(cell => 
        // Handle cells with commas, quotes, or newlines
        cell.includes(",") || cell.includes("\"") || cell.includes("\n") 
          ? `"${cell.replace(/"/g, '""')}"` 
          : cell
      ).join(",")
    ).join("\n");
  };

  // Handle download
  const handleDownload = () => {
    const csvContent = convertToCSV(rows);
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    
    let downloadName = fileName || 'file.csv';
    
    // If fileName doesn't have an extension, add .csv
    if (fileName && !fileName.includes('.')) {
      downloadName += '.csv';
    }
    
    a.download = downloadName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div className={styles.csvContainer}>
      <div className={styles.codeToolbar} style={{ marginBottom: '10px' }}>
        <div className={styles.toolbarRight}>
          <button 
            className={styles.toolbarButton}
            onClick={handleDownload}
            title="Download file"
          >
            Download
          </button>
        </div>
      </div>
      <table className={styles.csvTable}>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td style={{ textAlign: "center" }}>
                No data available
              </td>
            </tr>
          ) : rows.map((row, rowIndex) => (
            <tr key={`row-${rowIndex}`}>
              {row.map((cell, cellIndex) => (
                <td key={`cell-${rowIndex}-${cellIndex}`}>{cell}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CSVPreview;